import React from 'react';
import clx from "classnames";
import { useState } from "react"
import { FiArrowDown, FiBell, FiBellOff, FiLogOut, FiPlay, FiStar, FiUserPlus, FiX } from 'react-icons/fi'
import { useModal } from '../../../stores/useModal';

export const GroupDetail = ({mobile}) => {

    const [tab, setTab] = useState(1);
    const {open} = useModal(state=>state)

    const preview = (path) => {
      open({type:'preview', values:{path} })
     }

    return(
      <div className={clx(
        mobile && 'w-screen',
        'detail col-span-3 dark:bg-[#1e2126] bg-white dark:text-white overflow-y-auto h-screen'
      )} >
      <div className="m-5 mb-3">
        <div className="flex mt-4 itmes-center flex-col items-center text-center">
          <div className="w-14 h-14 bg-gray-500 rounded-full"></div>
          <div className="my-2">
            <div className="font-semibold">Productive Team</div>
            <div className="text-gray-500">27 members</div>
          </div>
        </div>
        <ul className="flex justify-center text-gray-500">
          <li
            className="flex items-center flex-col cursor-pointer m-3 p-3 px-6 rounded-md bg-zinc-100 hover:bg-zinc-200 dark:bg-zinc-800 dark:hover:bg-zinc-900"
          >
            <FiUserPlus className="stroke-gray-500" />
            <p>Add</p>
          </li>
          <li
            className="flex items-center flex-col cursor-pointer m-3 p-3 px-6 rounded-md bg-zinc-100 hover:bg-zinc-200 dark:bg-zinc-800 dark:hover:bg-zinc-900"
          >
            <FiBellOff className="stroke-gray-500" />
            <p>Mute</p>
          </li>
          <li
            className="flex items-center flex-col cursor-pointer m-3 p-3 px-6 rounded-md bg-zinc-100 hover:bg-zinc-200 dark:bg-zinc-800 dark:hover:bg-zinc-900"
          >
            <FiLogOut className="stroke-gray-500" />
            <p>Leave</p>
          </li>
        </ul>
  
        <div className="">
          <div className="text-zinc-400 font-medium">Description</div>
          <div className="text-zinc-400 text-sm">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit dolor
            beatae praesentium. Totam quibusdam, pariatur accusamus
            perferendis repudiandae.
          </div>
        </div>
      </div>
  
      <ul className="mx-3">
        <li
          className="flex justify-between items-center dark:hover:bg-zinc-700 hover:bg-gray-200 cursor-pointer rounded-full"
        >
          <div>
            <div className="flex gap-3 p-2 items-center">
              <div className="relative">
                <img src="/images/avatars/9.png" className="h-10" />
                <div
                  className="absolute right-0 bottom-0 rounded-full h-3 w-3 bg-green-500 border border-white border-2"
                ></div>
              </div>
              <div className="">
                <div className="flex">
                  <p className="font-medium">Jared Edwards</p>
                </div>
                <div className="text-blue-500 text-sm">Working on UI/UX</div>
              </div>
            </div>
          </div>
          <div className="pr-4">
            <FiStar className="fill-blue-500 h-6 stroke-none" /> 
          </div>
        </li>
        <li
          className="flex justify-between items-center dark:hover:bg-zinc-700 hover:bg-gray-200 cursor-pointer rounded-full"
        >
          <div className="flex gap-3 p-2 items-center">
            <div className="relative">
              <img src="/images/avatars/f.png" className="h-10" />
              <div
                className="absolute right-0 bottom-0 rounded-full h-3 w-3 bg-yellow-500 border border-white border-2"
              ></div>
            </div>
            <div className="">
              <div className="flex">
                <p className="text-[#1ab698] font-medium">Andrew Michael</p>
              </div>
              <div className="text-gray-500 text-sm">
                Last seem 40 minutes ago
              </div>
            </div>
          </div>
          <div className="pr-4">
            <FiStar className="fill-blue-500 h-6 stroke-none" /> 
          </div>
        </li>
        <li
          className="flex justify-between items-center dark:hover:bg-zinc-700 hover:bg-gray-200 cursor-pointer rounded-full"
        >
          <div className="flex gap-3 p-2 items-center">
            <div className="relative">
              <img src="/images/avatars/a.png" className="h-10" />
              <div
                className="absolute right-0 bottom-0 rounded-full h-3 w-3 bg-red-500 border border-white border-2"
              ></div>
            </div>
            <div className="">
              <div className="flex"><p className="font-medium">Denis</p></div>
              <div className="text-gray-500 text-sm">Last seem 2 hours ago</div>
            </div>
          </div>
        </li>
        <li
          className="flex justify-between items-center dark:hover:bg-zinc-700 hover:bg-gray-200 cursor-pointer rounded-full"
        >
          <div className="flex gap-3 p-2 items-center">
            <div className="relative">
              <img src="/images/avatars/o.png" className="h-10" />
              <div
                className="absolute right-0 bottom-0 rounded-full h-3 w-3 bg-green-500 border border-white border-2"
              ></div>
            </div>
            <div className="">
              <div className="flex"><p className="font-medium">Jonah Larson</p></div>
              <div className="text-blue-500 text-sm">Developing</div>
            </div>
          </div>
        </li>
      </ul>
  
      <div className="flex justify-between items-start mt-4 mx-5">
        <div className="flex gap-1 items-center">
          <FiBell className="h-5 cursor-pointer" />
          <p>Notification</p>
        </div>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            value=""
            className="sr-only peer"
          />
          <div
            className="w-9 h-5 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"
          ></div>
        </label>
      </div>
  
      <div x-data="{tab:1}" className="m-5">
        <ul
          className="mb-3 text-sm dark:bg-zinc-700 bg-gray-100 flex items-center justify-between rounded-lg"
        >
           {[
            'Photos',
            'File',
            'Link',
            'Video',
            'Audio',
          ].map((item,key)=>(
              <li
                onClick={()=>setTab(key+1)}
                className={clx(tab==key+1 && 'dark:bg-zinc-600 bg-white rounded-lg', 'p-2 w-full m-1 flex items-center justify-center cursor-pointer dark:text-zinc-400 text-gray-600')}
              >
                {item}
              </li>
          ))}
        </ul>
  
  
  
        <div className={clx('grid grid-cols-3 gap-2', {'hidden':tab!=1})} >
          {[
            'butterfly-g3f01a9434_1920.jpg',
            'rose-gbef08720a_1920.jpg',
            'Rectangle 4.png',
            'Rectangle 5.png',
            'Rectangle 7.png',
            'Rectangle 8.png',

          ].map(item=>(
            <div className="h-24 overflow-hidden rounded-md cursor-pointer">
                <img
                  onClick={()=>preview(`/images/shared/${item}`)}
                  src={`/images/shared/${item}`}
                  className="h-full w-full object-cover"
                />
            </div>
          ))}
       
        </div>
  
        <ul className={clx({'hidden':tab!=2})} >
          <li
            className="relative p-2 bg-gray-100 dark:bg-zinc-800 dark:hover:bg-gray-800 hover:bg-gray-200 rounded-md mb-2 cursor-pointer"
          >
            <div className="flex gap-2 flex justify-between items-center">
              <div className="flex gap-2 items-center">
                <div>
                  <div
                    className="w-10 h-10 bg-gray-50 bg-zinc-400 dark:bg-gray-500 rounded-md"
                  ></div>
                </div>
                <div>
                  <div className="dark:text-gray-200">filename.pdf</div>
                  <div className="text-sm text-gray-500">15MB 21.08.2023</div>
                </div>
              </div>
              <div
                className="dark:bg-gray-600 rounded-full w-8 h-8 flex items-center justify-center"
              >
                <FiArrowDown className="h-5 w-5" />
              </div>
            </div>
            <div className="actions-file"></div>
          </li>
        </ul>
  
        <div className={clx({'hidden':tab!=3})} >
          <ul className="grid gap-1">
            <li
              className="flex gap-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-500/10 p-1 rounded-md"
            >
              <div className="h-14 overflow-hidden rounded-md cursor-pointer">
                <img
                  // @click="photo='/images/shared/Rectangle 8.png';preview=true"
                  src="/images/shared/Rectangle 8.png"
                  className="h-full w-full object-cover"
                />
              </div>
              <div>
                <h3 className="font-semibold text-gray-500 dark:text-gray-100">
                  Google
                </h3>
                <a href="#" className="text-gray-400">https://www.google.com</a>
              </div>
            </li>
          </ul>
        </div>
  
        <div className={clx('grid grid-cols-2 gap-2', {'hidden':tab!=4})} >
          <div
            className="h-24 overflow-hidden rounded-md cursor-pointer bg-black/50 flex items-center justify-center"
          >
            <FiPlay className="h-5 stroke-none fill-gray-200 z-50" /> 
          </div>
          <div
            className="h-24 overflow-hidden rounded-md cursor-pointer bg-black/50 flex items-center justify-center"
          >
            <FiPlay
              className="h-5 stroke-none fill-gray-200 z-50"
            />
          </div>
        </div>
  
        <ul className={clx({'hidden':tab!=2})}  >
          <li
            className="relative p-2 bg-gray-100 dark:bg-zinc-800 dark:hover:bg-gray-800 hover:bg-gray-200 mb-2 cursor-pointer rounded-full"
          >
            <div className="flex gap-2 flex justify-between items-center">
              <div className="flex gap-2 items-center">
                <div>
                  <div
                    className="w-10 h-10 bg-gray-50 bg-zinc-400 dark:bg-gray-500 rounded-full"
                  ></div>
                </div>
                <div>
                  <div className="flex items-center">
                    <FiPlay
                      className="h-5 stroke-none fill-gray-400 dark:fill-gray-300"
                    />
                    <div className="dark:text-gray-200">
                      Apocalyptica - Path.mp4
                    </div>
                  </div>
                  <div className="hidden text-sm text-gray-500">
                    15MB 21.08.2023
                  </div>
                </div>
              </div>
              <div
                className="hidden dark:bg-gray-600 rounded-full w-8 h-8 flex items-center justify-center"
              >
                <FiArrowDown className="h-5 w-5" />
              </div>
            </div>
            <div className="actions-file"></div>
          </li>
        </ul>
      </div>
  
      {/** Show in mobile for closing as drawer **/}
      <div
        className="absolute top-2 left-0 px-5 right-0 md:hidden flex justify-between"
      >
        <div></div>
        <div
          // @click="mobileDetail=false"
          className="cursor-pointer hover:bg-gray-400 dark:hover:bg-gray-700 rounded-full w-8 h-8 flex items-center justify-center"
        >
          <FiX className="h-5 text-gray-400" />
        </div>
      </div>
    </div>
    )
}
  